module.exports = __webpack_public_path__ + "assets/img/8a1e95f9169533513b4d3bc84f6ce29e.svg";